(() => {
  if (window.ksQuickCartLoaded) return;
  window.ksQuickCartLoaded = true;
  const goal = () => document.querySelector('[data-ks-goal]');
  const root = () => goal()?.dataset.root || window.Shopify?.routes?.root || '/';
  let sequence = 0;
  let pending = false;
  const money = value => new Intl.NumberFormat(document.documentElement.lang || 'en-IN', {style: 'currency', currency: 'INR'}).format(value / 100);
  function update(cart) {
    document.querySelectorAll('[data-home-offer]').forEach(el => {
      el.hidden = cart.currency !== 'INR';
      const remaining = Math.max(0,54901-cart.items_subtotal_price);
      const component = el.querySelector('ks-progress-option');
      const detail = remaining ? el.dataset.remaining.replace('__AMOUNT__',money(remaining)) : el.dataset.reached;
      if (component?.update) component.update({value:cart.items_subtotal_price,maximum:54901,detail});
    });
    document.querySelectorAll('[data-ks-header-offer]').forEach(el => {
      el.hidden = cart.currency !== 'INR';
      const percent = Math.max(0, Math.min(100, cart.items_subtotal_price / 54901 * 100));
      el.querySelector('progress').value = percent;
      el.querySelector('.ks-header-offer-track').style.setProperty('--header-progress', percent + '%');
    });
    document.querySelectorAll('[data-ks-cart-count]').forEach(n => n.textContent = cart.item_count);
    document.querySelectorAll('[data-ks-goal]').forEach(el => {
      el.querySelectorAll('[data-ks-cart-count]').forEach(n => n.textContent = cart.item_count);
      if (cart.currency !== 'INR') return;
      const remaining = Math.max(0, 54901 - cart.items_subtotal_price);
      const bar = el.querySelector('progress');
      if (bar) {
        bar.value = Math.max(0, Math.min(100, cart.items_subtotal_price / 54901 * 100));
        bar.closest(".ks-offer-track")?.style.setProperty("--ks-progress", bar.value + "%");
        el.querySelector(".ks-offer-dial")?.style.setProperty("--ks-progress", bar.value + "%");
        const percent = el.querySelector("[data-ks-goal-percent]");
        if (percent) { percent.replaceChildren(document.createTextNode(Math.floor(bar.value)), Object.assign(document.createElement("i"), {textContent:"%"})); }
      }
      const msg = el.querySelector('[data-ks-goal-message]');
      if (msg) msg.textContent = remaining ? el.dataset.remaining.replace('__AMOUNT__', money(remaining)) : el.dataset.reached;
    });
  }
  async function refresh() {
    const current = ++sequence;
    const response = await fetch(root() + 'cart.js', {headers: {'Accept': 'application/json'}, cache: 'no-store'});
    if (!response.ok) throw new Error('cart');
    const cart = await response.json();
    if (current === sequence) update(cart);
    return cart;
  }
  function feedback() {
    const source = goal();
    if (!source) return;
    let panel = document.querySelector('.ks-cart-feedback');
    if (!panel) {
      panel = document.createElement('aside'); panel.className = 'ks-cart-feedback';
      const close = document.createElement('button'); close.type = 'button'; close.textContent = '×'; close.setAttribute('aria-label', 'Close cart confirmation'); close.onclick = () => panel.hidden = true;
      const status = document.createElement('p'); status.setAttribute('role', 'status');
      const links = source.querySelector('.ks-goal-actions').cloneNode(true);
      links.hidden = false;
      panel.append(close, status, links); document.body.append(panel);
    }
    panel.querySelector('p').textContent = source.dataset.added + ' ' + (source.querySelector('[data-ks-goal-message]')?.textContent || '');
    panel.querySelector('[data-ks-cart-count]').textContent = source.querySelector('[data-ks-cart-count]').textContent;
    panel.hidden = false;
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-ks-copy]');
    if (!button) return;
    const original = button.innerHTML;
    try {
      await navigator.clipboard.writeText(button.dataset.ksCopy);
      button.textContent = button.dataset.copied;
      setTimeout(() => { button.innerHTML = original; }, 1800);
    } catch { button.textContent = button.dataset.ksCopy; }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ks-add]');
    if (!form || !goal()) return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (pending) return;
    pending = true; ++sequence;
    const button = form.querySelector('button'); const status = form.querySelector('[role="status"]');
    const label = button.textContent; button.disabled = true; button.textContent = goal().dataset.adding; status.textContent = '';
    let added = false;
    try {
      const response = await fetch(root() + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body:new FormData(form)});
      const result = await response.json();
      if (!response.ok) { status.textContent = typeof result.description === 'string' ? result.description : goal().dataset.error; return; }
      added = true;
      await refresh(); status.textContent = goal().dataset.added; feedback();
      document.dispatchEvent(new CustomEvent('ks:cart-updated'));
    } catch { status.textContent = added ? goal().dataset.refreshError : goal().dataset.error; }
    finally { button.disabled = false; button.textContent = label; pending = false; }
  }, true);
  // Refresh after native product forms, cart drawers and Scarlet pairing requests.
  if ('PerformanceObserver' in window) {
    let refreshTimer;
    try {
      const cartObserver = new PerformanceObserver(list => {
        const changed = list.getEntries().some(entry => {
          try {
            const url = new URL(entry.name, location.href);
            return url.origin === location.origin && ['add','change','update','clear'].some(action => url.pathname.endsWith('/cart/' + action) || url.pathname.endsWith('/cart/' + action + '.js'));
          } catch { return false; }
        });
        if (changed && goal()) {
          clearTimeout(refreshTimer);
          refreshTimer = setTimeout(() => refresh().catch(() => {
            document.querySelectorAll('[data-ks-goal]').forEach(el => {
              const message = el.querySelector('[data-ks-goal-message]');
              if (message) message.textContent = el.dataset.refreshError;
            });
          }), 180);
        }
      });
      cartObserver.observe({type:'resource', buffered:false});
    } catch {}
  }
  window.addEventListener('pageshow', () => refresh().catch(() => {}));
  window.addEventListener('focus', () => { if (!pending) refresh().catch(() => {}); });
  document.addEventListener('shopify:section:load', () => refresh().catch(() => {}));
})();
